import {svgIconWrapper} from '../svg-icon-wrapper';

import RingcentralRegular from './ringcentral-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <RingcentralRegular {...props} />;
}

SvgComponent.iconName = 'ringcentralRegular';

export const RingcentralRegularIcon = svgIconWrapper(SvgComponent);
